import { LegalShell } from './LegalShell';

// PLACEHOLDER copy — Legal team must replace the body before production.
// Update TERMS_VERSION in shared/legalVersion.ts when the effective date changes;
// the first-login T&C acceptance gate compares against that version.

export function PrivacyPolicyPage() {
  return (
    <LegalShell title="Privacy Policy" effectiveDate="2026-08-03">
      <div className="bg-warning-soft border border-warning/40 rounded p-3 text-[11px] text-warning-strong">
        <strong>PLACEHOLDER:</strong> Legal team replaces this document before production release.
      </div>

      <section>
        <h2 className="font-bold text-navy">1. Who we are</h2>
        <p>
          DreamTrials is a multi-tenant Clinical Trial Management System operated
          by Zertain India Private Limited (&ldquo;we&rdquo;, &ldquo;our&rdquo;, &ldquo;us&rdquo;). This policy explains
          what personal information we collect from users of the DreamTrials
          platform, why we collect it, and how it is protected.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">2. Data we collect</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Account data: full name, work email, role, site membership, MFA enrolment state.</li>
          <li>Authentication data: password hash, TOTP seed (KMS-envelope-encrypted), recovery codes (bcrypt-hashed), IP address, user agent, session timestamps.</li>
          <li>Study operations data: subject reference numbers, visit dates, form responses, adverse events, e-consent status.</li>
          <li>Protected Health Information (PHI): only where explicitly captured (subject contact info, demographics). PHI is masked by default and only revealed under an active grant with audit.</li>
          <li>Audit trail: every state-changing action is recorded with user, timestamp, IP, and old/new values.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-bold text-navy">3. How we use it</h2>
        <p>
          Data is used solely for operating the clinical trial workflows the
          sponsor has commissioned: authentication, delegation of authority,
          e-consent capture, visit scheduling, safety reporting, and regulatory
          audit. We do not sell personal data. We do not use PHI for advertising.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">4. Security</h2>
        <p>
          Transport encryption via TLS 1.2+; PHI encrypted at rest with AWS KMS;
          per-tenant S3 storage with Server-Side AES256 encryption and versioning;
          audit trail written to an immutable WORM store with 7-year retention.
          Access requires multi-factor authentication.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">5. Retention</h2>
        <p>
          Study data is retained per the sponsor&rsquo;s protocol and applicable
          regulations (typically 15+ years for clinical records). Audit records
          are retained for a minimum of 7 years.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">6. Your rights</h2>
        <p>
          Contact your Site Administrator or the Data Protection Officer at
          <a href="mailto:dpo@zertain.com" className="text-blue"> dpo@zertain.com</a>
          {' '}to request access, correction, or deletion of your data, subject to
          the sponsor&rsquo;s regulatory retention obligations.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">7. Changes</h2>
        <p>
          We may update this policy from time to time. When we do, we notify
          users on next login and require re-acceptance of the Terms &amp;
          Conditions if material changes are made.
        </p>
      </section>
    </LegalShell>
  );
}
